import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Row, Col, Form } from "antd";
import { useIntl } from "react-intl";
import moment from "moment";

import RangePickerItem, {
  getDateFromRangePicker,
} from "../../app/generic/rangePickerItem";
import InputItem from "../../app/generic/inputItem";
import TableFilter from "../../app/generic/tableFilter";
import CheckboxItem from "../../app/generic/checkboxItem";
import FilterSubmit from "../../app/generic/tableFilter/filterSubmit";

const dateTimeFrom = moment(moment.now()).add(-12, "months");

const formName = "invoice-list";

function InvoiceListFilter({
  form,
  showFilter,
  loadInvoices,
  onSetShowFilter,
}) {
  const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 15 },
    colon: false,
  };
  const intl = useIntl();
  const { getFieldDecorator } = form;

  const [filterState] = useState(
    useSelector((state) => state.filter[formName])
  );
  useEffect(
    () => filterState && onSetShowFilter(true),
    [filterState, onSetShowFilter]
  );

  useEffect(() => {
    loadInvoices && loadInvoices(filterState && filterState.data);
  }, [loadInvoices, filterState]);

  const handleFiltering = useCallback(
    (e, onSetFilterState) => {
      e.preventDefault();
      form.validateFields((err, values) => {
        if (!err) {
          const params = {
            ...values,
            issueDateFrom: getDateFromRangePicker(values.issueDate, 0),
            issueDateTo: getDateFromRangePicker(values.issueDate, 1),
            issueDate: undefined,
            taxableDateFrom: getDateFromRangePicker(values.taxableDate, 0),
            taxableDateTo: getDateFromRangePicker(values.taxableDate, 1),
            taxableDate: undefined,
            dueDateFrom: getDateFromRangePicker(values.dueDate, 0),
            dueDateTo: getDateFromRangePicker(values.dueDate, 1),
            dueDate: undefined,
            payDateFrom: getDateFromRangePicker(values.payDate, 0),
            payDateTo: getDateFromRangePicker(values.payDate, 1),
            payDate: undefined,
          };
          loadInvoices(params);
          onSetFilterState(params);
        }
      });
    },
    [form, loadInvoices]
  );

  return (
    <TableFilter showFilter={showFilter}>
      <Form {...formItemLayout}>
        <Row>
          <Col span={12}>
            <InputItem
              label={intl.formatMessage({
                id: "invoice.codeFull",
                defaultMessage: "Číslo faktury",
              })}
              fieldName="code"
              formItemLayout={formItemLayout}
              getFieldDecorator={getFieldDecorator}
            />
            <RangePickerItem
              showRanges
              fieldName="issueDate"
              label={intl.formatMessage({
                id: "invoice.issueDate",
                defaultMessage: "Datum vystavení",
              })}
              initialDateFrom={dateTimeFrom}
              formItemLayout={formItemLayout}
              getFieldDecorator={getFieldDecorator}
            />
            <RangePickerItem
              showRanges
              fieldName="dueDate"
              label={intl.formatMessage({
                id: "invoice.dueDate",
                defaultMessage: "Datum splatnosti",
              })}
              formItemLayout={formItemLayout}
              getFieldDecorator={getFieldDecorator}
            />
            <CheckboxItem
              fieldName="afterPayDate"
              formItemLayout={formItemLayout}
              label={intl.formatMessage({
                id: "invoice.afterPayDate",
                defaultMessage: "Pouze faktury po splatnosti",
              })}
              getFieldDecorator={getFieldDecorator}
            />
          </Col>
          <Col span={12}>
            <CheckboxItem
              fieldName="onlyNotPaid"
              formItemLayout={formItemLayout}
              label={intl.formatMessage({
                id: "invoice.onlyNotPaid",
                defaultMessage: "Pouze nezaplacené faktury",
              })}
              getFieldDecorator={getFieldDecorator}
            />
            <RangePickerItem
              showRanges
              fieldName="taxableDate"
              label={intl.formatMessage({
                id: "invoice.taxableDate",
                defaultMessage: "Datum zdanitelného plnění",
              })}
              formItemLayout={formItemLayout}
              getFieldDecorator={getFieldDecorator}
            />
            <RangePickerItem
              showRanges
              fieldName="payDate"
              label={intl.formatMessage({
                id: "invoice.payDate",
                defaultMessage: "Datum úhrady",
              })}
              formItemLayout={formItemLayout}
              getFieldDecorator={getFieldDecorator}
            />
            <FilterSubmit
              form={form}
              formName={formName}
              filterState={filterState}
              onFilterClick={handleFiltering}
            />
          </Col>
        </Row>
      </Form>
    </TableFilter>
  );
}

export default Form.create()(InvoiceListFilter);
